export const MODAL_ARIA_LABELLEDBY = 'modalHeading';
